import React, {useCallback} from "react";
import DataManager from "../../DataManagers/DataManager";
import {Button, Dropdown, Icon, Radio} from "antd";
import {currentSceneIndexSelector, showStartScreenSelector} from "../../Redux/selectors";
import {BORDER_RADIUS_FOR_COMPONENTS} from "../../constants";
import {useDispatch, useSelector} from "react-redux";
import {_handleSceneChange} from "../../Redux/Actions/mapActions";

import OneTimeClickHereToolTipForNavArrows from './OneTimeClickHereToolTipForNavArrows'

const slideMenuStyle = {
	backgroundColor: 'white',
	padding: 12,
	borderRadius: BORDER_RADIUS_FOR_COMPONENTS,
	zIndex: 10000000
}
const radioStyle = {
	display: 'block',
	height: '30px',
	lineHeight: '30px',
};

const SlideNavigationSlideMenu = () => {
	const currentSceneIndex = useSelector(currentSceneIndexSelector)
	const dispatch = useDispatch()
	
	const scenes = DataManager.getStoryScenes()
	
	return (
		<div className="slide-menu-container">
			<Radio.Group onChange={e => dispatch(_handleSceneChange(+e.target.value))} value={currentSceneIndex}>
				{scenes.map((scene, index) => (
					<Radio key={index} value={index} style={radioStyle}
								 className={index === currentSceneIndex ? 'bold-radio-text' : ''}>
						{`${index + 1} - ${scene.title}`}
					</Radio>
				))}
			</Radio.Group>
		</div>
	)
}

export default () => {
	const currentSceneIndex = useSelector(currentSceneIndexSelector)
	const showStartScreen = useSelector(showStartScreenSelector)
	const dispatch = useDispatch()
	
	const decrementSlide = useCallback(
		() => dispatch(_handleSceneChange(currentSceneIndex - 1)),
		[currentSceneIndex],
	)
	
	const incrementSlide = useCallback(
		() => dispatch(_handleSceneChange(currentSceneIndex + 1)),
		[currentSceneIndex],
	)
	
	const scenes = DataManager.getStoryScenes()
	const type = 'link'
	
	if (showStartScreen || scenes.length === 1) {
		return null
	}
	
	return (
		<div className="story-navigation-buttons-container">
			<div>
				<Button.Group size="large" type={type} className={"story-navigation-buttons container-with-a-shadow"}>
					<Button
						type={type}
						ghost={currentSceneIndex === 0}
						disabled={currentSceneIndex === 0}
						onClick={decrementSlide}
					>
						<Icon type="left"/>
					</Button>
					
					<Dropdown
						overlayStyle={slideMenuStyle}
						overlay={<SlideNavigationSlideMenu/>}
						placement={"bottomCenter"}
						trigger={["click"]}
					>
						<Button type={type}>
							<Icon type="menu"/>
						</Button>
					</Dropdown>
					
					<Button
						type={type}
						ghost={currentSceneIndex === scenes.length - 1}
						disabled={currentSceneIndex === scenes.length - 1}
						onClick={incrementSlide}
					>
						<OneTimeClickHereToolTipForNavArrows />
					</Button>
				</Button.Group>
				<div className="small-sub-text dark" style={{textAlign: 'center', marginTop: 4}}>
					{`Slide ${currentSceneIndex + 1} of ${scenes.length}`}
				</div>
			</div>
		</div>
	)
}
